// Session storage of the portal: localStorage under a `sculpt.account.` prefix, memory behind it for a
// blocked storage (private mode). Tokens ride `Authorization:` headers (api.ts), never cookies — the
// portal is a first-party page, so none of the add-in's cross-site cookie dance is needed here.

export const TOKEN_KEYS = ['accessToken', 'tokenType', 'refreshToken'] as const;
export type TokenKey = (typeof TOKEN_KEYS)[number];

const PREFIX = 'sculpt.account.';
const memory = new Map<TokenKey, string>();

function key(name: TokenKey): string {
  return PREFIX + name;
}

export function writeToken(name: TokenKey, value: string): void {
  memory.set(name, value);
  try {
    localStorage.setItem(key(name), value);
  } catch {
    /* storage blocked: memory still holds it */
  }
}

export function readToken(name: TokenKey): string | null {
  try {
    const stored = localStorage.getItem(key(name));
    if (stored !== null) return stored;
  } catch {
    /* fall through to memory */
  }
  return memory.get(name) ?? null;
}

export function clearTokens(): void {
  for (const name of TOKEN_KEYS) {
    memory.delete(name);
    try {
      localStorage.removeItem(key(name));
    } catch {
      /* nothing to do */
    }
  }
}

export function hasSession(): boolean {
  return readToken('accessToken') !== null;
}
